import serviceEncuestado from '@/services/GsEncuesta/encuestado'

export default {
  ENCUESTADO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_FIND_ALL_RENIEC(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.findByDni(params.dni).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_CREATE_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.createAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_UPDATE_WITH_VALIDATION_DNI(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.updateWithValidationDni(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADO_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestado.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
